import { Typography } from 'antd'
import { TitleProps } from 'antd/es/typography/Title'
import classNames from 'classnames'

interface IBaseTitleProps {
  title: string
  level?: TitleProps['level']
  className?: string
}
function BaseTitle(props: IBaseTitleProps) {
  const { title, level = 2, className } = props
  const { Title } = Typography

  return (
    <Title
      level={level}
      className={classNames(
        'm-0 text-neutral-700 font-medium text-2xl',
        {
          'text-[32px]': level === 1,
          'leading-10': level === 1
        },
        className
      )}
    >
      {title}
    </Title>
  )
}

export default BaseTitle
